export const GOOGLE_DRIVE_CDN = 'https://lh3.googleusercontent.com/d/';
export const GOOGLE_DRIVE_VIDEO = 'https://drive.google.com/file/d/';

// valores según privilegios
export const CONFIG = {
    admin: { route: '/nin-admin', text: 'NIN Admin', hasAccess: true },
    user: { route: '/mi-cuenta', text: 'Cuenta', hasAccess: false }
};